import React from "react";
import CompanyExperts from "./company_experts";
import CompanyPrTeam from "./company_pr_team";
import CompanyProducts from "./company_products";
import CompanyBrands from "./company_brands";
import CompanyOverview from "./company_overview";

// Replaces the old <CompanyTabs>: the same section components, now rendered as a
// vertical stack of shared <SectionCard>s instead of react-bootstrap tabs. The former "About Us"
// body is now <CompanyOverview> — description + fact tiles, titled "Overview" for naming
// consistency with the other entity pages (Media Outlet already said Overview).
//
// Experts, PR Team, Products, Brands, and Overview are all self-contained section cards — each
// carries its own <SectionCard>, its own visibility rules (collapse-when-empty, plus page_config for
// PR Team/Brands, subtype for Products), so they are mounted here unconditionally rather than
// wrapped and gated.
function CompanySections() {
  return (
    <div className="container-fluid px-0">
      {/* Overview leads the stack, as the design draws it — the company describes itself before
          the rosters. */}
      <CompanyOverview />

      <CompanyExperts />

      <CompanyPrTeam />

      <CompanyProducts />

      <CompanyBrands />
    </div>
  );
}

export default CompanySections;
